module.exports = __webpack_public_path__ + "img/img_map_store.6f37376d.png";